import React from 'react'
import styled from 'styled-components'

import Reveal from '../../common/Reveal'
import Loading from '../../common/Loading'
import HomePeoplePerson from './HomePeoplePerson'

import steps from '../../../images/zebra.jpg'

const Wrapper = styled.section`
	position: relative;
	background-color: ${props => props.theme.secondary.bg2};
	background: url(${steps}) repeat;
	display: flex;
	align-items: center;
	justify-content: center;
	min-height: 36em;
	padding: 6em 25px;
	transform: translate3d(0,0,0);

	@media screen and (min-width: 1001px) {
		padding: 4em 50px;
	}
`

const Inner = styled.div`
	text-align: center;
	width: 100%;
	padding: 0 25px;
	max-width: 22em;

	@media screen and (min-width: 601px) and (max-width: 1000px) {
		max-width: 44em;
	}

	@media screen and (min-width: 1001px) {
		max-width: 68em;
	}

	h2 {
		color: #fff;
		display: block;
		margin: 0 auto 1.5em;
		font-size: 1.8em;
		padding-top: 1.84em;
		height: 5em;
		width: 5em;
		background-color: ${props => props.theme.secondary.bg3};
		border-radius: 100%;
		text-shadow: 3px 3px 0 ${props => props.theme.main.bg};

		@media screen and (min-width: 501px) {
			margin-bottom: 1.8em;
		}
	}
`

const People = ({ people }) => (
	<Wrapper className="home-people">
		<Inner className="home-people-inner">
			<Reveal duration={1} initialStyles={{autoAlpha: 0}} finalStyles={{autoAlpha: 1}}>
				<div>
					<h2>PEOPLE</h2>
				</div>
			</Reveal>
			{ people.length > 0
				? <Reveal>
					{people.map((person,i) => (
						<HomePeoplePerson key={person[0]}
							num={i}
							name={person[0]}
							img={person[1]['data']['url']}/>
					))}
				</Reveal>
				: <Loading color="#fff"/>
			}
		</Inner>
	</Wrapper>
)

export default People


// WEBPACK FOOTER //
// /opt/build/repo/src/components/pages/home/HomePeople.js